import React ,{ useState }from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@mui/material'
import Modal from './modal'
import LineinputV2 from './lineinputV2'
import { Item } from './snippets'
import { updatePassword } from '../../store/common/common_action'
import { redirectToLogin } from './helper'
import { useTranslation } from '../../i18n/I18nProvider'

const UpdatePassword = (props) => {
  const { translations } = useTranslation()
  const pf = translations?.profile || {}
  const { updateModal, updateAlert } = { ...props }
  const dispatch = useDispatch()
  const common = useSelector((state) => state?.common)
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const { loginData } = common
  const {intBranchID,intUserID,intLogID} = {...loginData}
  const validate=()=>{
    if(!newPassword){
      updateAlert({ show: true, msg: pf.pleaseEnterNewPassword || "Please Enter New Password", nextId: '' })
      return false
    }
    if(newPassword!==confirmPassword){
      updateAlert({ show: true, msg: pf.passwordsDoNotMatch || "New Password And Confirm Password Do Not Match", nextId: '' })
      return false
    }
    return true
  }
  const onSave = () => {
    if(validate()){
      const data ={
        intBranchID: intBranchID,
        intUserID: intUserID,
        intLoginID: "",
        intOldPassword: currentPassword,
        intNewPassword: newPassword
      }
      dispatch(updatePassword(data)).then((res)=>{
        console.log(res)
        const {Message,status} = res
        if(status==='Success'){
          sessionStorage.clear()
          redirectToLogin()
        }else{
          updateAlert({ show: true, msg: Message, nextId: '' })
        }
      }).catch((e)=>{})
    }
  }
  return (
    <>
      <Modal headTxt={pf.updatePassword || 'Update Password'} width={'30%'} updateModal={updateModal}>
        <Item sx={{ width: '100%', marginTop: '20px' }} className={'input--wrapper'}>
          <LineinputV2 label={pf.userName || 'User Name'} disabled value={loginData.strUserName} />
        </Item>
        <Item sx={{ width: '100%' }} className={'input--wrapper'}>
          <LineinputV2 label={pf.currentPassword || 'Current Password'} type="password" icon="pwd" value={currentPassword} onBlur={(e) => setCurrentPassword(e.target.value)} />
        </Item>
        <Item sx={{ width: '100%' }} className={'input--wrapper'}>
          <LineinputV2 label={pf.newPassword || 'New Password'} type="password" icon="pwd" value={newPassword} onBlur={(e) => setNewPassword(e.target.value)} />
        </Item>
        <Item sx={{ width: '100%' }} className={'input--wrapper'}>
          <LineinputV2 label={pf.confirmNewPassword || 'Confirm New Password'} type="password" icon="pwd" value={confirmPassword} onBlur={(e) => setConfirmPassword(e.target.value)} />
        </Item>
        <Item sx={{ width: '100%' }} className={'input--wrapper'}>
          <Button
            variant="contained"
            style={{
              width: '100%',
              height: '41px',
              backgroundColor: '#fe5200',
              fontSize: '15px',
              textTransform: 'Uppercase',
              color: '#fff',
              fontWeight: 'bold',
            }}
            onClick={() => onSave()}
          >
            {pf.updatePassword || 'Update Password'}
          </Button>
        </Item>
      </Modal>
    </>
  )
}

export default UpdatePassword
